import Stack from '@mui/material/Stack';
import { useForm } from 'react-hook-form';

import { ContactFields } from '@/components/form/ContactFields';

import { State } from '../State';

interface SampleContact {
  name: string;
  title: string;
  email: string;
  phone: string;
}

export function ContactFieldsExamples() {
  const {
    register,
    formState: { errors },
  } = useForm<SampleContact>({
    defaultValues: {
      name: 'Alex Sample',
      title: 'Director',
      email: 'alex@example.org',
      phone: '555-0100',
    },
  });

  return (
    <State
      title="The four parts of a contact"
      note="A prefix turns the labels into 'Billing contact name' and so on."
    >
      <Stack spacing={2.5} sx={{ maxWidth: 560 }}>
        <ContactFields
          names={{ name: 'name', title: 'title', email: 'email', phone: 'phone' }}
          register={register}
          errors={errors}
          testId="gallery-contact-fields"
        />
      </Stack>
    </State>
  );
}
